import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import { DEFAULT_ERROR_MESSAGE } from '../../constants/ErrorMessageConstants';

import { bodyContainerStyles, contentContainerStyles, wideLayoutContainerStyles } from './styles';

import TransitionWrapper from '../TransitionWrapper';

import type React from 'react';

export type WizardBodyTemplateProps = {
  children?: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  isTransitioning?: boolean;
  hasError?: boolean;
  subtitle?: React.ReactNode;
  title: React.ReactNode;
  mobileTitle?: React.ReactNode;
  footer?: React.ReactNode;
  progressStepper?: React.ReactNode;
};

const WizardBodyTemplate = ({
  children,
  description = '',
  icon = null,
  isTransitioning = false,
  hasError = false,
  subtitle = '',
  title,
  mobileTitle = '',
  footer = null,
  progressStepper = null,
}: WizardBodyTemplateProps) => {
  const renderError = () => (
    <Paragraph css={{ margin: 'auto', textAlign: 'center', color: 'text.feedback.critical.strong' }}>
      {DEFAULT_ERROR_MESSAGE}
    </Paragraph>
  );

  const renderContent = () => (
    <>
      <Box css={{ lg: { marginInline: '800' } }}>
        {icon && (
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '800',
            }}
          >
            <Box css={{ position: 'relative', height: '120px', width: '120px' }}>{icon}</Box>
          </Box>
        )}
        <Box css={{ paddingBottom: '200', textAlign: 'center' }}>
          <Heading level={1} textStyle="heading-md" css={{ mdDown: { display: 'none' } }}>
            {title}
          </Heading>
          {mobileTitle ? (
            <Heading level={1} textStyle="heading-sm" css={{ md: { display: 'none' } }}>
              {mobileTitle}
            </Heading>
          ) : (
            <Heading level={1} textStyle="heading-sm" css={{ md: { display: 'none' } }}>
              {title}
            </Heading>
          )}
          {subtitle && (
            <Paragraph textStyle="body" data-testid="subtitle" css={{ paddingTop: '200' }}>
              {subtitle}
            </Paragraph>
          )}
          {description && (
            <Paragraph
              textStyle="body"
              data-testid="description"
              css={{ paddingTop: 'md', margin: 'auto', width: '100%', md: { maxWidth: '470px' } }}
            >
              {description}
            </Paragraph>
          )}
        </Box>
      </Box>
      {children}
    </>
  );

  return isTransitioning ? (
    <Box css={bodyContainerStyles}>
      <Box css={wideLayoutContainerStyles}>
        <Box css={contentContainerStyles}>
          {progressStepper}
          <TransitionWrapper isTransitioning={true} />
        </Box>
      </Box>
    </Box>
  ) : (
    <Box css={bodyContainerStyles}>
      <Box css={wideLayoutContainerStyles}>
        <Box css={contentContainerStyles}>
          <Box css={{ marginBottom: '800' }}>{progressStepper}</Box>
          {hasError ? renderError() : renderContent()}
        </Box>
        <Box css={{ marginInline: '136px', marginTop: '800', marginBottom: '88px' }}>{footer}</Box>
      </Box>
    </Box>
  );
};

export default WizardBodyTemplate;
